import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=a4f753b6&"
import script from "./Jumbotron.vue?vue&type=script&lang=js&"
export * from "./Jumbotron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports